import React from 'react';

function About() {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <main className="flex-grow py-12 px-4">
        <div className="max-w-4xl mx-auto bg-white p-10 shadow-xl rounded-xl text-gray-800 leading-relaxed text-[21px]">
          {/* Title block */}
          <h1 className="text-4xl font-bold mb-2 border-l-4 border-blue-600 pl-4">
            About Us
          </h1>
          <p className="text-sm text-gray-500 mb-10 text-right">Established in 2008</p>

          <section className="space-y-6">
            <p>
              Established in Nashville, TN in 2008 with a mission to simplify reliable hosting, Iword Hosting empowers businesses of all sizes
              with fast, secure, and scalable vps server deployment on hand crafted web hosting infrastructure. We’re proud to support startups, developers, agencies, and entrepreneurs with a personal approach that focuses on trust, uptime, world-class service, and endless scalability.
            </p>

            <p>
              <strong>Built on Experience. Powered by Integrity.</strong> At Iword Hosting, we don’t just rent servers — we’ve spent just under 20 years perfecting them.
              While intentionally starting small with a select group of clients, our infrastructure was built to scale — standing firm and battle-tested for high performance, reliability, and security.
            </p>

            <p>
  Whether you're launching your first site or scaling an online business, i-word.net delivers real support from real experts with nearly two decades of hands-on hosting experience. No overcrowded servers — just premium, optimized environments with personal attention and room to grow.
</p>

<p>
  We proudly offer enterprise-grade WordPress hosting powered by OpenLiteSpeed and Ubuntu 24.04 — a modern, high-performance stack designed for speed, efficiency, and scalability. OpenLiteSpeed is the open-source counterpart of LiteSpeed Enterprise, offering full HTTP/3 support and significantly faster performance than both Nginx and Apache.
</p>

<p>
  Our default WordPress deployments come preconfigured with:
  <br />
  • WordPress 6.8.1<br />
  • OpenLiteSpeed 1.8.3<br />
  • MariaDB 11.4<br />
  • PHP 8.3<br />
  • CertBot SSL (Latest)<br />
  • phpMyAdmin (Latest)<br />
  • Redis (Latest)<br />
  • Memcached (Latest)
</p>

<p>
  We also specialize in cPanel & WHM v128 environments running Rocky Linux 9.5 — built with precision, running MariaDB, and backed by years of industry-best reliability.
</p>

<p>
  Ready to launch? With one-click deployment of over 100+ applications and just a few easy steps, we’ll help you get your website online the right way — fast, stable, and future-proof.
</p>


            <p>
              <strong>Only a Few Can Match Our Flexibility.</strong> We proudly offer 12 operating systems to choose from, over 100+ one-click applications, and a wide range of custom configurations.
              With deployment available in 8 major U.S. cities and 32 global regions, we are one of the few cloud providers in the world offering this level of precision and choice at scale.
            </p>
          </section>

          <section className="mt-10 space-y-4">
            <h2 className="text-2xl font-semibold mb-2">Our Commitment to Uptime & Excellence</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>✔ 99.99% Uptime Guarantee</li>
              <li>✔ Tier-1 Data Center Network</li>
              <li>✔ Personalized Support Experience</li>
              <li>✔ Certified Hosting Infrastructure</li>
              <li>✔ Award-Winning Client Service</li>
              <li>✔ Expert Team with Proven Track Record</li>
              <li>✔ Minimalist by design. Scalable by nature.</li>
            </ul>
          </section>
        </div>
      </main>
    </div>
  );
}

export default About;
